import request from "@/utils/request";
import config from "@/config";
let serveUrl = config.baseUrl;
let personalCenterBaseUrl = config.personalCenterBaseUrl;

let adminCenterUrl = config.adminCenterUrl;
//获取数据中心列表
export function getPersonalCenter() {
  return request({
    url: `${serveUrl}portalCenter/api/rest/center/personalInterface/getPersonalList`,
    method: "get"
  });
}

// 获取下拉列表
export function getOptions(data){
	return request({
		url:`${serveUrl}portalCenter/api/rest/center/personalInterface/getInteface`,
		method: "get",
		params: data
	})
}

// 获取动态数据
export function getParams(data){
	return request({
		url:`${serveUrl}portalCenter/api/rest/center/personalInterface/getParam`,
		method: "get",
		params: data
	})
}

export function getDetails(data){
	return request({
		url: `${serveUrl}portalCenter/api/rest/center/personalInterface/getPsonal`,
		method: "get",
		params: data
	})
}

// 提交表单
export function submitForm(data){
	return request({
		url: `${serveUrl}portalCenter/api/rest/center/personalInterface/saveParam`,
		method: "post",
		data: data
	})
}
